import React from "react";
import "./Testimonials.css";

const testimonials = [
  {
    id: 1,
    name: "Mr. Ashish Upadhya",
    role: "Bharat Petroleum Corporation Limited (BPCL)",
    message:
      "Intelbuild demonstrated excellent technical expertise and delivered quality engineering solutions with professionalism, accuracy, and timely support throughout the project.",
    img: "/assets/images/testimonials/person 2.png",
  },
  {
    id: 2,
    name: "Mr. Abrar Shaikh ",
    role: "MARCO ",
    message:
      "The team provided practical engineering solutions with excellent coordination, responsiveness, and commitment to project delivery.",
    img: "/assets/images/testimonials/person 2.png",
  },
  {
    id: 3,
    name: "Mr. Gurusamy Pillai",
    role: "GCC Club & Hotels ",
    message:
      "We appreciate Intelbuild's professional approach, attention to detail, and ability to deliver reliable engineering services within the project timeline.",
    img: "/assets/images/testimonials/person 2.png",
  },
  {
    id: 4,
    name: "Abhishek Alreja",
    role: "Vijay Builders",
    message:
      "Intelbuild has been a dependable engineering partner, consistently delivering optimized designs, prompt technical support, and high-quality project execution.",
    img: "/assets/images/testimonials/person 2.png",
  },
];

const Testimonials = () => {
  return (
    <section className="testimonials-section">
      <h2 className="testimonials-title">What Our Clients Say</h2>

      <div className="testimonial-slider">
        <div className="testimonial-track">

          {testimonials.map((t) => (
            <div className="testimonial-card" key={t.id}>
              <div className="testimonial-img-box">
                <img src={t.img} alt={t.name} className="testimonial-img" />
              </div>

              <p className="testimonial-message">“{t.message}”</p>
              <h4 className="testimonial-name">{t.name}</h4>
              <p className="testimonial-role">{t.role}</p>
            </div>
          ))}

          {/* Duplicate for infinite scroll */}
          {testimonials.map((t) => (
            <div className="testimonial-card" key={t.id + '-copy'}>
              <div className="testimonial-img-box">
                <img src={t.img} alt={t.name} className="testimonial-img" />
              </div>

              <p className="testimonial-message">“{t.message}”</p>
              <h4 className="testimonial-name">{t.name}</h4>
              <p className="testimonial-role">{t.role}</p>
            </div>
          ))}

        </div>
      </div>
    </section>
  );
};

export default Testimonials;
